import Dashboard from '../components/Pages/Dashboard';
import AddNote from '../components/Pages/Dashboard/AddNote';
import SensorInfo from '../components/Pages/Dashboard/SensorInfo';
import TrendCharts from '../components/Pages/Dashboard/TrendCharts';
import GroupMap from '../components/Pages/GroupMap';
import MyProfile from '../components/Pages/MyProfile';
import Configure from '../components/Pages/Configure';
import Departments from '../components/Pages/Configure/Departments';
import NewDepartment from '../components/Pages/Configure/Departments/NewDepartment';
import AddLicense from '../components/Pages/Configure/Departments/AddLicense';
import ViewLicense from '../components/Pages/Configure/Departments/ViewLicense';
import DepartmentSettings from '../components/Pages/Configure/Departments/DepartmentSettings';
import Groups from '../components/Pages/Configure/Groups';
import NewGroup from '../components/Pages/Configure/Groups/NewGroup';
import AssignUsers from '../components/Pages/Configure/Groups/AssignUsers';
import AssignAlerts from '../components/Pages/Configure/Groups/AssignAlerts';
import MaintainDB from '../components/Pages/Configure/Groups/MaintainDB';
import EditGroup from '../components/Pages/Configure/Groups/EditGroup';
import Phrases from '../components/Pages/Configure/Phrases';
import NewPhrase from '../components/Pages/Configure/Phrases/NewPhrase';
import EditPhrase from '../components/Pages/Configure/Phrases/EditPhrase';
import Roles from '../components/Pages/Configure/Roles';
import NewRole from '../components/Pages/Configure/Roles/NewRole';
import EditRole from '../components/Pages/Configure/Roles/EditRole';
import Units from '../components/Pages/Configure/Units';
import NewUnit from '../components/Pages/Configure/Units/NewUnit';
import UsersConfig from '../components/Pages/Configure/Users';
import NewUserConfig from '../components/Pages/Configure/Users/NewUser';
import EditUserConfig from '../components/Pages/Configure/Users/EditUser';
import ResetPassword from '../components/Pages/Configure/Users/ResetPassword';
import RemoteDevices from '../components/Pages/Configure/RemoteDevices';
import NewRemoteDevice from '../components/Pages/Configure/RemoteDevices/NewRemoteDevice';
import EditRemoteDevice from '../components/Pages/Configure/RemoteDevices/EditRemoteDevice';
import AlarmIndicators from '../components/Pages/Configure/AlarmIndicators';
import NewAlarmIndicator from '../components/Pages/Configure/AlarmIndicators/NewAlarmIndicator';
import AIConfigureSensors from '../components/Pages/Configure/AlarmIndicators/ConfigureSensors';
import SensorTypes from '../components/Pages/Configure/SensorTypes';
import NewSensorType from '../components/Pages/Configure/SensorTypes/NewSensorType';
import EditSensorType from '../components/Pages/Configure/SensorTypes/EditSensorType';
import ValidationControlPanel from '../components/Pages/Configure/ValidationControlPanel';
import MobileConfigurations from '../components/Pages/Configure/MobileConfigurations';
import NewMobileConfiguration from '../components/Pages/Configure/MobileConfigurations/NewMobileConfiguration';
import EditMobileConfiguration from '../components/Pages/Configure/MobileConfigurations/EditMobileConfiguration';
import CopyMobileConfiguration from '../components/Pages/Configure/MobileConfigurations/CopyMobileConfiguration';
import ConfigSensors from '../components/Pages/Configure/MobileConfigurations/ConfigSensors';
import Reports from '../components/Pages/Reports';
import AlarmHistory from '../components/Pages/Reports/AlarmHistory';
import AuditReports from '../components/Pages/Reports/AuditReports';
import BatchReports from '../components/Pages/Reports/BatchReports';
import NewBatchReport from '../components/Pages/Reports/BatchReports/NewBatchReport';
import EditBatchReport from '../components/Pages/Reports/BatchReports/EditBatchReport';
import NewProcess from '../components/Pages/Reports/BatchReports/Processes/NewProcess';
import EditProcess from '../components/Pages/Reports/BatchReports/Processes/EditProcess';
import GroupStatus from '../components/Pages/Reports/GroupStatus';
import GroupStatusStatistics from '../components/Pages/Reports/GroupStatusStatistics';
import LimitsChanged from '../components/Pages/Reports/LimitsChanged';
import MKTMonitors from '../components/Pages/Reports/MKTMonitors';
import NewMKTMonitor from '../components/Pages/Reports/MKTMonitors/NewMKTMonitor';
import EditMKTMonitor from '../components/Pages/Reports/MKTMonitors/EditMKTMonitor';
import SensorMeasurementLog from '../components/Pages/Reports/SensorMeasurementLog';
import StatisticsDetail from '../components/Pages/Reports/StatisticsDetail';
import SDResult from '../components/Pages/Reports/StatisticsDetail/SDResult';
import TrendChartReport from '../components/Pages/Reports/TrendChart';
import UserNotes from '../components/Pages/Reports/UserNotes';
import SensorReport from '../components/Pages/Reports/SensorReport';
import MapViewer from '../components/Pages/MapViewer';
import Table from '../components/Pages/Table';
import Login from '../components/Pages/Login';
import ChangePassword from '../components/Pages/ChangePassword';
import ScheduledReports from '../components/Pages/Configure/ScheduledReports';
import NewScheduledReport from '../components/Pages/Configure/ScheduledReports/NewScheduledReport';
import EditScheduledReport from '../components/Pages/Configure/ScheduledReports/EditScheduledReport';
import Create from '../components/Pages/Create';
import Help from '../components/Pages/Help';
import EditUnit from '../components/Pages/Configure/Units/EditUnit';
import EditSensor from '../components/Pages/Configure/Groups/EditSensor';
import MapManagement from '../components/Pages/Configure/MapManagement';
import NewMap from '../components/Pages/Configure/MapManagement/NewMap';
import EditMap from '../components/Pages/Configure/MapManagement/EditMap';
import MapEditor from '../components/Pages/Configure/MapManagement/MapEditor';
import MobileConfigurationPresets from '../components/Pages/Configure/MobileConfigurations/MobileConfigurationPresets';
import ICSD from '../components/Pages/Configure/ImportCalibrationSwapData';
import SystemAdminDashboard from '../components/Pages/SystemAdminDashboard';
import ModifyEmailSchedule from '../components/Pages/SystemAdminDashboard/ModifyEmailSchedule';
import DashboardCustom from '../components/Pages/Configure/DashboardCustom';
import CustomDashboard from '../components/Pages/DashboardCustom';

export default [
  {
    path: '/',
    title: 'Dashboard',
    breadcrumb: 'Dashboard',
    breadcrumb_link: true,
    exact: true,
    component: Dashboard,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/custom-dashboard',
    title: 'Custom Dashboard',
    breadcrumb: 'Custom Dashboard',
    breadcrumb_link: true,
    exact: true,
    component: CustomDashboard,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/add-note',
    title: 'Add Note',
    breadcrumb: 'Add note',
    breadcrumb_link: true,
    exact: true,
    component: AddNote,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/sensor-info',
    title: 'Sensor Info',
    breadcrumb: 'Sensor Info',
    breadcrumb_link: true,
    exact: true,
    component: SensorInfo,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/trend-charts',
    title: 'Trend Charts',
    breadcrumb: 'Trend charts',
    breadcrumb_link: true,
    exact: true,
    component: TrendCharts,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/group-map',
    title: 'Group Map',
    breadcrumb: 'Group Map',
    breadcrumb_link: true,
    exact: true,
    component: GroupMap,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/reports',
    title: 'Reports',
    breadcrumb: 'Reports',
    breadcrumb_link: true,
    exact: true,
    component: Reports,
    requireAuth: true,
    permission: 'API.Reports',
  },
  {
    path: '/reports/alarm-history',
    title: 'Alarm History',
    breadcrumb: 'Alarm history',
    breadcrumb_link: true,
    exact: true,
    component: AlarmHistory,
    requireAuth: true,
    permission: 'API.Reports.AlarmHistory',
  },
  {
    path: '/reports/audit-reports',
    title: 'Audit Reports',
    breadcrumb: 'Audit reports',
    breadcrumb_link: true,
    exact: true,
    component: AuditReports,
    requireAuth: true,
    permission: 'API.Reports.Audits',
  },
  {
    path: '/reports/batch-reports',
    title: 'Batch Reports',
    breadcrumb: 'Batch reports',
    breadcrumb_link: true,
    exact: true,
    component: BatchReports,
    requireAuth: true,
    permission: 'API.Reports.BatchReports',
  },
  {
    path: '/reports/batch-reports/new-batch-report',
    title: 'New Batch Report for Department:',
    breadcrumb: 'New Batch Report',
    breadcrumb_link: true,
    exact: true,
    component: NewBatchReport,
    requireAuth: true,
    permission: 'API.Reports.BatchReports',
  },
  {
    path: '/reports/batch-reports/edit-batch-report',
    title: 'Edit Batch Report',
    breadcrumb: 'Edit Batch Report',
    breadcrumb_link: true,
    exact: true,
    component: EditBatchReport,
    requireAuth: true,
    permission: 'API.Reports.BatchReports',
  },
  {
    path: '/reports/batch-reports/new-process',
    title: 'New Process for:',
    breadcrumb: 'New Batch Report',
    breadcrumb_link: true,
    exact: true,
    component: NewProcess,
    requireAuth: true,
    permission: 'API.Reports.BatchReports',
  },
  {
    path: '/reports/batch-reports/edit-process',
    title: 'Edit Process for:',
    breadcrumb: 'New Batch Report',
    breadcrumb_link: true,
    exact: true,
    component: EditProcess,
    requireAuth: true,
    permission: 'API.Reports.BatchReports',
  },
  {
    path: '/reports/group-status',
    title: 'Group Status',
    breadcrumb: 'Group status',
    breadcrumb_link: true,
    exact: true,
    component: GroupStatus,
    requireAuth: true,
    permission: 'API.Reports.GroupStatus',
  },
  {
    path: '/reports/group-status-statistics',
    title: 'Group Status Statistics',
    breadcrumb: 'Group status statistics',
    breadcrumb_link: true,
    exact: true,
    component: GroupStatusStatistics,
    requireAuth: true,
    permission: 'API.Reports.GroupStatusStatistics',
  },
  {
    path: '/reports/limits-changed',
    title: 'Limits Changed',
    breadcrumb: 'Limits changed',
    breadcrumb_link: true,
    exact: true,
    component: LimitsChanged,
    requireAuth: true,
    permission: 'API.Reports.LimitsChanged',
  },
  {
    path: '/reports/mkt-monitors',
    title: 'MKT Monitors',
    breadcrumb: 'MKT monitors',
    breadcrumb_link: true,
    exact: true,
    component: MKTMonitors,
    requireAuth: true,
    permission: 'API.Reports.MKTMonitors',
  },
  {
    path: '/reports/mkt-monitors/new-mkt-monitor/:departmentId',
    title: 'Create MKT Monitor',
    breadcrumb: 'Create MKT monitor',
    breadcrumb_link: true,
    exact: true,
    component: NewMKTMonitor,
    requireAuth: true,
    permission: 'API.Reports.MKTMonitors',
  },
  {
    path: '/reports/mkt-monitors/edit-mkt-monitor/:departmentId/:id',
    title: 'Edit MKT Monitor',
    breadcrumb: 'Edit MKT monitor',
    breadcrumb_link: true,
    exact: true,
    component: EditMKTMonitor,
    requireAuth: true,
    permission: 'API.Reports.MKTMonitors',
  },
  {
    path: '/reports/sensor-measurement-log',
    title: 'Sensor Measurement Log',
    breadcrumb: 'Sensor measurement log',
    breadcrumb_link: true,
    exact: true,
    component: SensorMeasurementLog,
    requireAuth: true,
    permission: 'API.Reports.MeasurementLog',
  },
  {
    path: '/reports/statistics-detail',
    title: 'Statistics Detail',
    breadcrumb: 'Statistics detail',
    breadcrumb_link: true,
    exact: true,
    component: StatisticsDetail,
    requireAuth: true,
    permission: 'API.Reports.StatisticsDetail',
  },
  {
    path: '/reports/statistics-detail/result',
    title: 'Statistics Detail Result',
    breadcrumb: 'Statistics detail',
    breadcrumb_link: true,
    exact: true,
    component: SDResult,
    requireAuth: true,
    permission: 'API.Reports.StatisticsDetail',
  },
  {
    path: '/reports/trend-chart',
    title: 'Trend Chart',
    breadcrumb: 'Trend chart',
    breadcrumb_link: true,
    exact: true,
    component: TrendChartReport,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/reports/user-notes',
    title: 'User Notes',
    breadcrumb: 'User notes',
    breadcrumb_link: true,
    exact: true,
    component: UserNotes,
    requireAuth: true,
    permission: 'API.Reports.UserNotes',
  },
  {
    path: '/reports/sensor-report',
    title: 'Sensor Report',
    breadcrumb: 'Sensor report',
    breadcrumb_link: true,
    exact: true,
    component: SensorReport,
    requireAuth: true,
    permission: 'API.Reports.Sensor',
  },
  {
    path: '/system-admin-dashboard',
    title: 'System Admin Dashboard',
    breadcrumb: 'System admin dashboard',
    breadcrumb_link: true,
    exact: true,
    component: SystemAdminDashboard,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/system-admin-dashboard/modify-email-schedule',
    title: 'Modify Email Schedule',
    breadcrumb: 'Modify email schedule',
    breadcrumb_link: true,
    exact: true,
    component: ModifyEmailSchedule,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/main-map',
    title: 'Main Map',
    breadcrumb: 'Main map',
    breadcrumb_link: true,
    exact: true,
    component: MapViewer,
    requireAuth: true,
    permission: 'None',
  },
  {
    path: '/secondary-map',
    title: 'Secondary Map',
    breadcrumb: 'Secondary map',
    breadcrumb_link: true,
    exact: true,
    component: MapViewer,
    requireAuth: true,
    permission: 'None',
  },
  {
    path: '/table',
    title: 'Table',
    breadcrumb: 'Table',
    breadcrumb_link: false,
    exact: true,
    component: Table,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/my-profile',
    title: 'My Profile',
    breadcrumb: 'My profile',
    breadcrumb_link: true,
    exact: true,
    component: MyProfile,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/configure',
    title: 'Configure',
    breadcrumb: 'Configure',
    breadcrumb_link: true,
    exact: true,
    component: Configure,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/configure/departments',
    title: 'Departments Management',
    breadcrumb: 'Departments',
    breadcrumb_link: true,
    exact: true,
    component: Departments,
    requireAuth: true,
    permission: 'API.Department',
  },
  {
    path: '/configure/departments/new-department',
    title: 'Create Department',
    breadcrumb: 'Create department',
    breadcrumb_link: true,
    exact: true,
    component: NewDepartment,
    requireAuth: true,
    permission: 'API.Department',
  },
  {
    path: '/configure/departments/add-license/:id',
    title: 'Add license',
    breadcrumb: 'Departments',
    breadcrumb_link: true,
    exact: true,
    component: AddLicense,
    requireAuth: true,
    permission: 'API.Department',
  },
  {
    path: '/configure/departments/view-license/:id',
    title: 'View license',
    breadcrumb: 'Departments',
    breadcrumb_link: true,
    exact: true,
    component: ViewLicense,
    requireAuth: true,
    permission: 'API.Department',
  },
  {
    path: '/configure/departments/department-settings/:id',
    title: 'Department Settings',
    breadcrumb: 'Department settings',
    breadcrumb_link: true,
    exact: true,
    component: DepartmentSettings,
    requireAuth: true,
    permission: 'API.Department',
  },
  {
    path: '/configure/groups',
    title: 'Groups Management',
    breadcrumb: 'Groups',
    breadcrumb_link: true,
    exact: true,
    component: Groups,
    requireAuth: true,
    permission: 'API.GroupSetting',
  },
  {
    path: '/configure/groups/new-group',
    title: 'Create Group',
    breadcrumb: 'Create group',
    breadcrumb_link: true,
    exact: true,
    component: NewGroup,
    requireAuth: true,
    permission: 'API.GroupSetting',
  },
  {
    path: '/configure/groups/assign-users/:groupId',
    title: 'Assign Users',
    breadcrumb: 'Assign users',
    breadcrumb_link: true,
    exact: true,
    component: AssignUsers,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/configure/groups/assign-alerts/:groupId',
    title: 'Assign Alerts',
    breadcrumb: 'Assign alerts',
    breadcrumb_link: true,
    exact: true,
    component: AssignAlerts,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/configure/groups/maintain-db/:groupId',
    title: 'Maintain Database',
    breadcrumb: 'Maintain database',
    breadcrumb_link: true,
    exact: true,
    component: MaintainDB,
    requireAuth: true,
    permission: 'API.GroupSetting',
  },
  {
    path: '/configure/groups/edit-sensor',
    title: 'Edit Sensor',
    breadcrumb: 'Maintain database',
    breadcrumb_link: true,
    exact: true,
    component: EditSensor,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/configure/groups/edit-group/:id',
    title: 'Edit Group',
    breadcrumb: 'Edit group',
    breadcrumb_link: true,
    exact: true,
    component: EditGroup,
    requireAuth: true,
    permission: 'API.GroupSetting',
  },
  {
    path: '/configure/phrases',
    title: 'Phrases Management',
    breadcrumb: 'Phrases',
    breadcrumb_link: true,
    exact: true,
    component: Phrases,
    requireAuth: true,
    permission: 'API.AckPhrases',
  },
  {
    path: '/configure/phrases/new-phrase/:departmentId',
    title: 'Create Phrase',
    breadcrumb: 'Create phrase',
    breadcrumb_link: true,
    exact: true,
    component: NewPhrase,
    requireAuth: true,
    permission: 'API.AckPhrases',
  },
  {
    path: '/configure/phrases/edit-phrase/:departmentId/:id',
    title: 'Edit Phrase',
    breadcrumb: 'Edit phrase',
    breadcrumb_link: true,
    exact: true,
    component: EditPhrase,
    requireAuth: true,
    permission: 'API.AckPhrases',
  },
  {
    path: '/configure/roles',
    title: 'Roles Management',
    breadcrumb: 'Roles',
    breadcrumb_link: true,
    exact: true,
    component: Roles,
    requireAuth: true,
    permission: 'AbpIdentity.Roles',
  },
  {
    path: '/configure/roles/new-role',
    title: 'Create Role',
    breadcrumb: 'Create role',
    breadcrumb_link: true,
    exact: true,
    component: NewRole,
    requireAuth: true,
    permission: 'AbpIdentity.Roles',
  },
  {
    path: '/configure/roles/edit-role/:roleId',
    title: 'Edit Role',
    breadcrumb: 'Edit role',
    breadcrumb_link: true,
    exact: true,
    component: EditRole,
    requireAuth: true,
    permission: 'AbpIdentity.Roles',
  },
  {
    path: '/configure/scheduled-reports',
    title: 'Scheduled Reports',
    breadcrumb: 'Scheduled reports',
    breadcrumb_link: true,
    exact: true,
    component: ScheduledReports,
    requireAuth: true,
    permission: 'API.ScheduledReports',
  },
  {
    path: '/configure/scheduled-reports/new-scheduled-report/:departmentId',
    title: 'Create Scheduled Report',
    breadcrumb: 'Create scheduled report',
    breadcrumb_link: true,
    exact: true,
    component: NewScheduledReport,
    requireAuth: true,
    permission: 'API.ScheduledReports',
  },
  {
    path: '/configure/scheduled-reports/edit-scheduled-report/:departmentId/:id',
    title: 'Edit Scheduled Report',
    breadcrumb: 'Edit scheduled report',
    breadcrumb_link: true,
    exact: true,
    component: EditScheduledReport,
    requireAuth: true,
    permission: 'API.ScheduledReports',
  },
  {
    path: '/configure/units',
    title: 'Unit Management',
    breadcrumb: 'Unit Management',
    breadcrumb_link: true,
    exact: true,
    component: Units,
    requireAuth: true,
    permission: 'API.Units',
  },
  {
    path: '/configure/units/new-unit',
    title: 'Create Unit',
    breadcrumb: 'Create unit',
    breadcrumb_link: true,
    exact: true,
    component: NewUnit,
    requireAuth: true,
    permission: 'API.Units',
  },
  {
    path: '/configure/units/edit-unit/:unitId',
    title: 'Edit Unit',
    breadcrumb: 'Edit unit',
    breadcrumb_link: true,
    exact: true,
    component: EditUnit,
    requireAuth: true,
    permission: 'API.Units',
  },
  {
    path: '/configure/users',
    title: 'Users Management',
    breadcrumb: 'Users',
    breadcrumb_link: true,
    exact: true,
    component: UsersConfig,
    requireAuth: true,
    permission: 'API.Users',
  },
  {
    path: '/configure/users/new-user',
    title: 'Create User',
    breadcrumb: 'Create user',
    breadcrumb_link: true,
    exact: true,
    component: NewUserConfig,
    requireAuth: true,
    permission: 'API.Users',
  },
  {
    path: '/configure/users/edit-user/:id',
    title: 'Edit User',
    breadcrumb: 'Edit user',
    breadcrumb_link: true,
    exact: true,
    component: EditUserConfig,
    requireAuth: true,
    permission: 'API.Users',
  },
  {
    path: '/configure/users/reset-password/:userId',
    title: 'Reset Password',
    breadcrumb: 'Reset password',
    breadcrumb_link: true,
    exact: true,
    component: ResetPassword,
    requireAuth: true,
    permission: 'API.Users.ResetPassword',
  },
  {
    path: '/configure/remote-devices',
    title: 'Remote Devices Management',
    breadcrumb: 'Remote devices management',
    breadcrumb_link: true,
    exact: true,
    component: RemoteDevices,
    requireAuth: true,
    permission: 'API.RemoteStations',
  },
  {
    path: '/configure/remote-devices/new-remote-device',
    title: 'Create Remote Device',
    breadcrumb: 'Create remote device',
    breadcrumb_link: true,
    exact: true,
    component: NewRemoteDevice,
    requireAuth: true,
    permission: 'API.RemoteStations',
  },
  {
    path: '/configure/remote-devices/edit-remote-device/:id',
    title: 'Edit Remote Device',
    breadcrumb: 'Edit remote device',
    breadcrumb_link: true,
    exact: true,
    component: EditRemoteDevice,
    requireAuth: true,
    permission: 'API.RemoteStations',
  },
  {
    path: '/configure/alarm-indicators',
    title: 'Alarm Indicator Settings',
    breadcrumb: 'Alarm indicator settings',
    breadcrumb_link: true,
    exact: true,
    component: AlarmIndicators,
    requireAuth: true,
    permission: 'API.AlarmIndicators',
  },
  {
    path: '/configure/alarm-indicators/new-alarm-indicator/:deptId',
    title: 'New Alarm Indicator',
    breadcrumb: 'New alarm indicator',
    breadcrumb_link: true,
    exact: true,
    component: NewAlarmIndicator,
    requireAuth: true,
    permission: 'API.AlarmIndicators',
  },
  {
    path: '/configure/alarm-indicators/configure-sensors/:id',
    title: 'Configure Sensors',
    breadcrumb: 'Configure sensors',
    breadcrumb_link: true,
    exact: true,
    component: AIConfigureSensors,
    requireAuth: true,
    permission: 'API.AlarmIndicators',
  },
  {
    path: '/configure/sensor-types',
    title: 'Sensor Type Settings',
    breadcrumb: 'Sensor Type Settings',
    breadcrumb_link: true,
    exact: true,
    component: SensorTypes,
    requireAuth: true,
    permission: 'API.SensorTypes',
  },
  {
    path: '/configure/sensor-types/new-sensor-type/:deptId',
    title: 'Create Sensor Type',
    breadcrumb: 'Create sensor type',
    breadcrumb_link: true,
    exact: true,
    component: NewSensorType,
    requireAuth: true,
    permission: 'API.SensorTypes',
  },
  {
    path: '/configure/sensor-types/edit-sensor-type/:id',
    title: 'Edit Sensor Type',
    breadcrumb: 'Edit sensor type',
    breadcrumb_link: true,
    exact: true,
    component: EditSensorType,
    requireAuth: true,
    permission: 'API.SensorTypes',
  },
  {
    path: '/configure/validation-control-panel',
    title: 'Validation Control Panel',
    breadcrumb: 'Validation control panel',
    breadcrumb_link: true,
    exact: true,
    component: ValidationControlPanel,
    requireAuth: true,
    permission: 'API.Sensors.Enable',
  },
  {
    path: '/configure/mobile-configurations/presets',
    title: 'Mobile Configuration Presets',
    breadcrumb: 'Mobile Configurations',
    breadcrumb_link: true,
    exact: true,
    component: MobileConfigurationPresets,
    requireAuth: true,
    permission: 'API.MobileConfigurations',
  },
  {
    path: '/configure/mobile-configurations',
    title: 'Mobile Configurations',
    breadcrumb: 'Mobile Configurations',
    breadcrumb_link: true,
    exact: true,
    component: MobileConfigurations,
    requireAuth: true,
    permission: 'API.MobileConfigurations',
  },
  {
    path: '/configure/mobile-configurations/new-mobile-configuration',
    title: 'Create Mobile Configuration',
    breadcrumb: 'Create Mobile Configuration',
    breadcrumb_link: true,
    exact: true,
    component: NewMobileConfiguration,
    requireAuth: true,
    permission: 'API.MobileConfigurations',
  },
  {
    path: '/configure/mobile-configurations/edit-mobile-configuration',
    title: 'Edit Mobile Configuration',
    breadcrumb: 'Edit Mobile Configuration',
    breadcrumb_link: true,
    exact: true,
    component: EditMobileConfiguration,
    requireAuth: true,
    permission: 'API.MobileConfigurations',
  },
  {
    path: '/configure/mobile-configurations/config-sensors',
    title: 'Configure Sensors',
    breadcrumb: 'Config Sensors',
    breadcrumb_link: true,
    exact: true,
    component: ConfigSensors,
    requireAuth: true,
    permission: 'API.MobileConfigurations',
  },
  {
    path: '/configure/mobile-configurations/copy-mobile-configuration',
    title: 'Copy Mobile Configuration',
    breadcrumb: 'Copy Mobile Configuration',
    breadcrumb_link: true,
    exact: true,
    component: CopyMobileConfiguration,
    requireAuth: true,
    permission: 'API.MobileConfigurations',
  },
  {
    path: '/configure/map-management',
    title: 'Map Management',
    breadcrumb: 'Create',
    breadcrumb_link: true,
    exact: true,
    component: MapManagement,
    requireAuth: true,
    permission: 'API.Maps',
  },
  {
    path: '/configure/map-management/new',
    title: 'Create Map',
    breadcrumb: 'Create',
    breadcrumb_link: true,
    exact: true,
    component: NewMap,
    requireAuth: true,
    permission: 'API.Maps',
  },
  {
    path: '/configure/map-management/edit',
    title: 'Edit Map',
    breadcrumb: 'Create',
    breadcrumb_link: true,
    exact: true,
    component: EditMap,
    requireAuth: true,
    permission: 'API.Maps',
  },
  {
    path: '/configure/import-calibration-swap-data',
    title: 'Import Calibration Swap Data',
    breadcrumb: 'Import Calibration Swap Data',
    breadcrumb_link: true,
    exact: true,
    component: ICSD,
    requireAuth: true,
    permission: 'API.SensorCalibrations',
  },
  {
    path: '/configure/configure-custom-dashboard',
    title: 'Configure Custom Dashboard',
    breadcrumb: 'Configure custom dashboard',
    breadcrumb_link: true,
    exact: true,
    component: DashboardCustom,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/create',
    title: 'Create ...',
    breadcrumb: 'Create',
    breadcrumb_link: true,
    exact: true,
    component: Create,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/help',
    title: 'Help',
    breadcrumb: 'Create',
    breadcrumb_link: true,
    exact: true,
    component: Help,
    requireAuth: true,
    permission: 'Admin',
  },
  {
    path: '/login',
    title: 'Login',
    breadcrumb: 'Login',
    breadcrumb_link: false,
    exact: true,
    component: Login,
    requireAuth: false,
  },
  {
    path: '/change-password',
    title: 'Change Password',
    breadcrumb: 'Change Password',
    breadcrumb_link: false,
    exact: true,
    component: ChangePassword,
    requireAuth: false,
  },
];
